module.exports = __webpack_public_path__ + "/images/logo-app-apple-it.0a6a96b.svg";